import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopLeft16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconRadiusTopLeft16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.181 2.681h3a.5.5 0 0 0 0-1h-3a5.5 5.5 0 0 0-5.5 5.5v3a.5.5 0 0 0 1 0v-3a4.5 4.5 0 0 1 4.5-4.5m-2.112 10a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m5.75-4.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-.75 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m.75-5.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-2.75 7.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopLeft16);
